import React from 'react'
import classnames from "classnames";
import { Modal, Form } from "react-bootstrap";

//import action
import { addSpotPair } from '../../actions/tradePairAction'

//import lib
import { toastAlert } from '../../lib/toastAlert';
import isEmpty from '../../lib/isEmpty'
import { Addoffertaghook, Editoffertaghook } from '../../actions/P2PCreateaction';
import { connectWallet } from '../../lib/useWallet';
import { toast } from 'react-toastify';
import contractProvider from '../../lib/contractProvider';
import config from '../../lib/config';


const options = [{ 'value': "binance", 'label': "binance" }, { 'value': "off", 'label': "Off" }];


const initialFormValue = {
    // "firstCurrencyId": " ",
    // "firstFloatDigit": "",
    // "secondCurrencyId": " ",
    // "secondFloatDigit": "",
    // "minPricePercentage": "",
    // "maxPricePercentage": "",
    // "minQuantity": "",
    // "maxQuantity": "",
    // "maker_rebate": "",
    // "taker_fees": "",
    // "markupPercentage": "",
    // "markPrice": "",
    // "botstatus": "off",
    "status": null, //active ,Inactive
    "name": "",
    "description": "",
    "id": ""
}

const pageType = {
    connectWallet: 'connectWallet',
    complete: 'complete',
    enterAmount: 'enterAmount',
}

class CompletedTradeModal extends React.Component {
    constructor() {
        super();
        this.state = {
            formValue: initialFormValue,
            errors: {},
            loader: false,
            page: pageType.connectWallet,
            connectedAccount: null,
            disableStatus: false,
            amountToDeposit: 0
        };
    }

    handleChange = e => {
        e.preventDefault();
        let { name, id, value } = e.target;
        let formData = { ...this.state.formValue, ...{ [id]: value } };
        this.setState({ formValue: formData });
        if (!isEmpty(value)) {
            this.setState({ errors: {} })
        }
    };

    handleClose = () => {
        const { onHide } = this.props;
        onHide();
        this.setState({ 
            formValue: initialFormValue,
            errors: {},
            loader: false,
            page: pageType.connectWallet,
            connectedAccount: null,
            disableStatus: false,
            amountToDeposit: 0
         });

    }

    handleSubmit = async e => {
        e.preventDefault();
        try {
            const { formValue } = this.state;
            // const { fetchData } = this.props;

            let reqData = formValue;
            this.setState({ 'disableStatus': true });
            if (this.state?.connectedAccount) {

                console.log('contracccttttt');
            }
            else {
                this.setState({ 'page': pageType.connectWallet });
            }
        }
        catch (err) { }
        this.setState({ 'disableStatus': false });
    }
    componentWillUnmount() {
        this.setState({ "loader": false });
    }

    componentDidMount() {
        // console.log("domponent did mount" , this.props);
        // var data = this.state.formValue;
        // data.name = this.props?.record?.name;
        // data.description = this.props?.record?.description;
        // data.status = this.props?.record?.status
        if (this?.props?.record?.amount) {
            this.setState({ amountToDeposit: this.props.record.amount })
        }
    }
    componentWillReceiveProps(nextProps) {
        console.log("component will receive props", nextProps);
        var data = this.state.formValue;
        data.name = nextProps?.record?.Name;
        data.description = nextProps?.record?.Description;
        data.status = nextProps?.record?.status;
        data.id = nextProps?.record?._id;
        this.setState({ formValue: data });
    }

    connectWalletTypeClick = async (type) => {
        this.setState({ disableStatus: true });
        console.log('typeeeee', type, this?.props?.payload?.chainId)
        // if (this?.props?.payload?.chainId) {
        let chainId = this.props?.record?.chainId || '11155111';
        let accountDetails = await connectWallet(type, chainId);
        if (!accountDetails?.accountAddress) {
            this.setState({ disableStatus: false });
            return toast.error(accountDetails?.errorMessage ? accountDetails?.errorMessage : "Try-Again");
        }
        else {
            toast.success("Connected Successfully");
            this.setState({ page: pageType.enterAmount });
        }
        console.log('accountDetails', accountDetails);
        this.setState({ connectedAccount: accountDetails });
        console.log('nottdisconnectedddd')
        // }
        // else {
        //     toast.error("No chain id report admin");
        // }
        this.setState({ disableStatus: false });
    }

    handleExchange = async () => {
        const { record: depositData } = this.props;
        const { connectedAccount, amountToDeposit } = this.state;
        console.log("depositDataconnectedAccount", depositData, connectedAccount);

        try {
            if (!connectedAccount?.accountAddress) {
                toastAlert("error", "Wallet not connected");
                return;
            }

            if (config?.ADMIN_WALLET_ADDRESS !== connectedAccount?.accountAddress.toLowerCase()) {
                toastAlert("error", "Please connect with the Admin Wallet");
                return;
            }

            const amountInWei = connectedAccount.web3.utils.toWei(
                amountToDeposit.toString(),
                "ether"
            );
            console.log("amountInWei", amountInWei);

            const result = await contractProvider.completeDeposit({
                accountAddress: connectedAccount.accountAddress,
                amount: amountInWei,
                web3: connectedAccount.web3,
                contractAddress: depositData.contractAddress,
                depositUniqueId: depositData.depositUniqueId,
                completeFullAmount: depositData.completeFullAmount,
                withdrawAddress: depositData.withdrawAddress.toLowerCase(),
            });

            console.log("contractresult", result);

            if (result?.error) {
                toastAlert("error", result.errorMessage || "Transaction failed.");
            } else {
                const payload = {
                    p2pOrderId: depositData?.p2pOrderId,
                    tradeHistoryId: depositData?.tradeHistoryId,
                    amount: depositData?.amount,
                };
                console.log("payload", payload);

                this.props.handleApproveDeposit(payload);
            }

        } catch (error) {
            console.error(error);
            toastAlert("error", error.message || "Something went wrong");
        }
    };

    handleAmountChange = (e) => {
        e.preventDefault();
        try {
            const { amountToDeposit } = this.state;

            let error = '';
            console.log('amountToerror', error, Number(amountToDeposit), Number(this.props?.record?.amount));

            if (amountToDeposit === '') {
                error = 'Amount is required';
            } else if (Number(amountToDeposit) <= 0) {
                error = 'Amount must be greater than zero';
            } else if (Number(this.props?.record?.amount) < Number(amountToDeposit)) {
                error = 'Deposit amount must be lesser than the pay amount';
            }

            if (error) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        amountToDeposit: error
                    }
                });
            } else {
                this.setState({ 'page': pageType.complete, errors: {...this.state.errors, amountToDeposit: ""} });
            }
        } catch (error) {
            console.log(error);
        }
    };




    render() {
        const { errors, loader, disableStatus } = this.state;
        const { markupPercentage, markPrice, maker_rebate, taker_fees, minPricePercentage, maxPricePercentage, maxQuantity, minQuantity, firstCurrencyId,
            firstFloatDigit, secondCurrencyId, secondFloatDigit, botstatus, status, amount, description } = this.state.formValue

        const { record } = this.props;
        console.log('recordddddd', record)
        console.log("propssss", this.props, this.state);


        return (
            <div>
                <Modal
                    show={true}
                    onHide={this.handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    size="lg"
                    centered
                    scrollable={true}
                    backdrop={false}
                >
                    {
                        this?.state?.page == pageType?.connectWallet ?
                            <>
                                <Modal.Header closeButton>
                                    <h4 className="modal-title">Connect Wallet</h4>
                                </Modal.Header>
                                <Modal.Body>

                                    <form noValidate id="add-spot">
                                        <p className='ed-modal__header-subtitle mb-4'>Choose Wallet</p>

                                        <div className='d-flex align-items-center gap-4'>
                                            <button
                                                type="button"
                                                class="ed-button__back-sm"
                                                onClick={() => this.connectWalletTypeClick('Metamask')}
                                                disabled={disableStatus}
                                            >
                                                <img
                                                    src={require('../../images/metamask.png')}
                                                />
                                                Metamask
                                            </button>
                                            {/* <button
                                                className='ed-button__submit-sm '
                                                onClick={() => this.connectWalletTypeClick('Walletconnect')}
                                                disabled={disableStatus}
                                            >
                                                <img
                                                    src={require('../../images/walletconnect.png')}
                                                />
                                                Wallet Connect
                                            </button> */}
                                        </div>

                                    </form>
                                </Modal.Body>
                            </>
                            :
                            this?.state?.page == pageType?.enterAmount ?
                                <>
                                    <Modal.Header closeButton>
                                        <h4 className="modal-title">Complete offer</h4>
                                    </Modal.Header>
                                    <Modal.Body>

                                        <form noValidate id="add-spot">

                                            <div className="row mt-2">
                                                <div className="col-md-3">
                                                    <label htmlFor="taker_fees">Enter Amount</label>
                                                </div>
                                                <div className="col-md-9">
                                                    {/* <input
                                                    onChange={this.handleChange}
                                                    value={amount}
                                                    name="amount"
                                                    error={errors.amount}
                                                    id="amount"
                                                    type="text"
                                                    className={classnames("form-control", {
                                                        invalid: errors.amount
                                                    })}
                                                /> */}
                                                    <input
                                                        onChange={(e) =>
                                                            this.setState({
                                                                amountToDeposit: e.target.value
                                                                    .replace(/[^0-9.]/g, '')        // allow only digits and one dot
                                                                    .replace(/(\..*?)\..*/g, '$1') // prevent multiple dots
                                                            })
                                                        }
                                                        value={this.state.amountToDeposit}
                                                        name="amountToDeposit"
                                                        error={errors.amountToDeposit}
                                                        id="amountToDeposit"
                                                        type="text"
                                                        className={classnames("form-control", {
                                                            invalid: errors.amountToDeposit
                                                        })}
                                                    />

                                                    <span className="text-danger">{errors.amountToDeposit}</span>
                                                </div>
                                            </div>

                                        </form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={this.props.onHide}
                                            disabled={disableStatus}
                                        >
                                            Close
                                        </button>
                                        <button
                                            onClick={this.handleAmountChange}
                                            className="btn btn-primary"
                                            disabled={disableStatus}
                                        >
                                            {disableStatus && <i class="fas fa-spinner fa-spin"></i>}
                                            Submit
                                        </button>
                                    </Modal.Footer>
                                </>
                                :
                                <>
                                    <Modal.Header closeButton>
                                        <h4 className="modal-title">Complete Deposit</h4>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <p className="text-dark">
                                            Are you sure you want to complete the deposit transaction?
                                        </p>
                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => this.setState({ page: pageType?.enterAmount })}
                                            >
                                                Back
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={this.handleExchange}
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    </Modal.Body>
                                </>
                    }
                </Modal>
            </div>
        )
    }
}



export default CompletedTradeModal;
